
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FF4A40","d":"M2.605 0h15.058s.683.005 1.183.177c.481.165.824.416.824.416l.003.002 7.681 6.525s.34.287.505.582c.133.238.141.674.141.674a.39.39 0 00-.001.022v17.518c0 1.163-1.15 2.084-2.605 2.084H2.604C1.15 28 0 27.08 0 25.916V2.084C0 .92 1.15 0 2.605 0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M7.1 15.495V18H5.635v-7.11h2.773c.534 0 1.003.098 1.406.294.407.195.72.473.938.835.218.358.327.766.327 1.225 0 .697-.24 1.247-.718 1.65-.475.4-1.134.601-1.977.601H7.1zm0-1.186h1.308c.388 0 .682-.092.884-.274.205-.182.308-.443.308-.781 0-.348-.103-.63-.308-.845-.205-.215-.488-.325-.85-.332H7.1v2.232zM12.09 18v-7.11h2.187c.625 0 1.184.142 1.675.425.495.28.88.68 1.157 1.202.277.517.415 1.106.415 1.767v.327c0 .661-.136 1.249-.41 1.763-.27.514-.652.913-1.147 1.196a3.348 3.348 0 01-1.675.43H12.09zm1.465-5.923v4.746h.708c.573 0 1.01-.187 1.313-.561.303-.375.457-.91.464-1.607v-.376c0-.722-.15-1.27-.45-1.64-.299-.375-.736-.562-1.313-.562h-.722zm9.316 3.018H20.06V18h-1.465v-7.11h4.629v1.187h-3.164v1.836h2.812v1.182z"}})])
          )
        }
      }
    